// src/components/Subscription/FeatureLockModal.js
import React from 'react';
import { Lock, Crown, Check, X, RefreshCw } from 'lucide-react';
import { useSubscription } from '../../Context/SubscriptionContext';
import './FeatureLockModal.css';

const FeatureLockModal = ({ isOpen, onClose, featureName, reason }) => {
  const { isExpired, subscriptionEndDate } = useSubscription();
  
  if (!isOpen) return null;

  const features = [
    'Unlimited invoices',
    'Unlimited quotations',
    'Client management',
    'Expense tracking',
    'Team management',
    'Advanced analytics',
    'Custom branding',
    'Priority support'
  ];

  const formatDate = (dateString) => {
    if (!dateString) return '';
    return new Date(dateString).toLocaleDateString('en-US', {
      year: 'numeric',
      month: 'long',
      day: 'numeric'
    });
  };

  return (
    <div className="feature-lock-overlay" onClick={onClose}>
      <div className="feature-lock-modal" onClick={(e) => e.stopPropagation()}>
        <button className="feature-lock-close" onClick={onClose}>
          <X size={20} />
        </button>

        <div className="feature-lock-header">
          <div className="feature-lock-icon">
            {isExpired ? <RefreshCw size={32} /> : <Lock size={32} />}
          </div>
          <h2 className="feature-lock-title">
            {isExpired ? 'Renew Your Subscription' : 'Upgrade to Premium'}
          </h2>
          <p className="feature-lock-subtitle">
            {isExpired 
              ? `Your subscription expired on ${formatDate(subscriptionEndDate)}. Renew now to regain access to all premium features.`
              : reason
            }
          </p>
        </div>

        <div className="feature-lock-content">
          <div className="feature-lock-features">
            <h3 className="feature-lock-features-title">
              <Crown size={20} />
              Premium Features
            </h3>
            <ul className="feature-lock-list">
              {features.map((feature, index) => (
                <li key={index} className="feature-lock-item">
                  <Check size={16} />
                  <span>{feature}</span>
                </li>
              ))}
            </ul>
          </div>

          <div className="feature-lock-pricing">
            <div className="feature-lock-price">
              <span className="feature-lock-currency">₹</span>
              <span className="feature-lock-amount">999</span>
              <span className="feature-lock-period">/month</span>
            </div>
            <button className="feature-lock-upgrade-btn">
              {isExpired ? <RefreshCw size={18} /> : <Crown size={18} />}
              {isExpired ? 'Renew Subscription' : 'Upgrade Now'}
            </button>
            <p className="feature-lock-note">
              Cancel anytime • No hidden fees
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default FeatureLockModal;